import React from "react";

import { templates } from "@reactivated";

import { StyleguideChrome } from "../components/StyleguideChrome";
import { StyleguideFormStates } from "../components/StyleguideFormStates";

export const Template = (
    props: templates.StyleguideFormStatesElementTemplate,
): React.JSX.Element => {
    // The component renders the fixture's own `#element-tester.l-capped-width`
    // root; the browser path nests it in the plain wrapper div exactly as the
    // legacy styleguide-browser-element.html did around the static fragment.
    const content = <StyleguideFormStates />;
    return (
        <StyleguideChrome storybook={props.storybook}>
            {props.storybook ? (
                content
            ) : (
                <div id="element-tester">{content}</div>
            )}
        </StyleguideChrome>
    );
};
